import React, { FC } from 'react';
import { Stack } from '@monorepo/nova-ui';
import { BannerContentProps } from '../types';
import { PlatformSection } from './platform-section';
import { PurchaseSection } from './purchase-section';

/**
 * Main banner content component that orchestrates the purchase and platform sections
 */
export const BannerContent: FC<BannerContentProps> = ({ tradingSystem }) => {
  return (
    <Stack
      id="banner-content"
      direction={{
        xs: 'column',
        md: 'row',
      }}
      p={{
        xs: 10,
      }}
      spacing={4}
      sx={{
        width: '100%',
        height: '100%',
        alignItems: 'flex-start',
      }}
    >
      <PurchaseSection />
      <PlatformSection tradingSystem={tradingSystem} />
    </Stack>
  );
};
